export const POMELO_STORES_TOP_BANNER = Object.freeze({
  keyMain: 'POMELO_STORES_TOP_HEADER',
  textMain: 'POMELO STORES',
  keySecondary: 'POMELO_STORES_TOP_DESCRIPTION',
  textSecondary: 'MEET POMELO IN REAL LIFE',
})

export const POMELO_STORES_LOCATION_DETAILS = Object.freeze({
  keyOpeningHours: 'POMELO_STORES_OPENING_HOURS',
  textOpeningHours: 'hours',
  keyLocation: 'POMELO_STORES_LOCATION',
  textLocation: 'location',
  keyGetDirection: 'POMELO_STORES_GET_DIRECTIONS',
  textGetDirection: 'get direction',
  keyContactUs: 'POMELO_STORES_CONTACT_US',
  textContactUs: 'contact us',
  keyCallUs: 'POMELO_STORES_CALL_US',
  textCallUs: 'call us',
  keyClosestStation: 'POMELO_STORES_CLOSEST_STATION',
  textClosestStation: 'closest station',
})
